import { CSSObject } from '@emotion/react'
import { Color } from '@opallabs/gem'
import { WithRequiredTheme } from '@opallabs/lapidary'

export const nodeViewWrapper: CSSObject = {
  paddingBlock: '6px',
  paddingInline: '0',
  userSelect: 'none',
  display: 'inline-block',
}

export const resource = ({ theme }: WithRequiredTheme): CSSObject => ({
  display: 'flex',
  alignItems: 'center',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '4px',
  lineHeight: 1,
  borderColor: Color[theme].Surface.N400,

  '.lapidary-icon': {
    display: 'inline',
  },

  '> div, > a': {
    display: 'inherit',
    alignItems: 'inherit',
  },

  '&[data-disabled="false"]:hover .hover-container': {
    position: 'relative',

    span: {
      // Maintain intrinsic width given by filesize
      visibility: 'hidden',
    },
    button: {
      display: 'inline',
    },
  },
})

export const resourceLink = ({ theme }: WithRequiredTheme): CSSObject => ({
  paddingBlock: '0',
  paddingInlineEnd: '12px',
  paddingInlineStart: '6px',
  textDecoration: 'none',
  color: 'inherit',
  alignSelf: 'stretch',

  '&:hover, &:hover + .hover-container': {
    backgroundColor: Color[theme].Translucent.A08,
  },
})

export const filename: CSSObject = {
  marginInlineStart: '6px',
  paddingBlockStart: '1px',
  lineHeight: '16px',
}

export const filesize: CSSObject = {
  color: '#6d7175',
  paddingBlock: '10px',
  paddingInlineEnd: '8px',
  paddingInlineStart: '4px',
  fontSize: '14px',
  // Ensure filesize is at least the same width as the delete button
  textAlign: 'end',
  minInlineSize: '34px',
}

export const deleteResource = ({ theme }: WithRequiredTheme): CSSObject => ({
  display: 'none',
  position: 'absolute',
  insetInlineEnd: 0,
  background: 'none',
  border: 0,
  borderRadius: '4px',
  cursor: 'pointer',
  paddingBlockStart: '4px',
  paddingInlineEnd: '6px',
  paddingBlockEnd: '3px',
  paddingInlineStart: '4px',
  margin: '4px',
  color: Color[theme].Surface.R100,

  '&:hover': {
    backgroundColor: Color[theme].Translucent.A08,
  },
})
